import { render, staticRenderFns } from "./tabsCustom-ourPrograms.vue?vue&type=template&id=c77f90e6&scoped=true&"
import script from "./tabsCustom-ourPrograms.vue?vue&type=script&lang=js&"
export * from "./tabsCustom-ourPrograms.vue?vue&type=script&lang=js&"
import style0 from "./tabsCustom-ourPrograms.vue?vue&type=style&index=0&id=c77f90e6&prod&lang=scss&scoped=true&"
import style1 from "./tabsCustom-ourPrograms.vue?vue&type=style&index=1&id=c77f90e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77f90e6",
  null
  
)

export default component.exports